import { render, staticRenderFns } from "./Control.vue?vue&type=template&id=b532b970&"
import script from "./Control.vue?vue&type=script&lang=ts&"
export * from "./Control.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports